module.exports = VueVideoPlayer;


//////////////////
// WEBPACK FOOTER
// external "VueVideoPlayer"
// module id = glBY
// module chunks = 22